export const DefaultList = [
    { label: '是', value: '1' },
    { label: '否', value: '0' },
];

export const StatisticsList = [
    { label: '金额', value: '0' },
    { label: '笔数', value: '1' },
];

/**
 * 1. auth为true时，直接返回
 * 2. auth为对象时，过滤出属性为true或对象的子模块
 */
export function genModules(modules, auth) {
    if (auth === true) {
        return modules;
    } else if (auth) {
        return modules.filter(m => !!auth[m.key]);
    }
    return [];
}

export function genSubAuth(auth, key) {
    if (auth === true) {
        return true;
    } else if (auth) {
        return auth[key] || false;
    }
    return false;
}

// {
//     // 请款数据分析整体权限
//     "requestDataAnalysis": {
//         // 请款代办
//         "requestToDo": {
//             // 未登记请款的合同记录
//             "unregisterRequest": {
//                 "table": {
//                     "editable": true
//                 },
//                 "histogramSpline": true,
//             },
//             // 已到达milestone日期未开票的清单
//             "arrivedMilestone": {
//                 "table": true,
//                 "pie": {
//                     "overMilestoneDay": true,
//                     "reasonClassify": true,
//                     "client": true,
//                     "ba": true,
//                 },
//                 "histogram": {
//                     "overMilestoneDay": true,
//                     "reasonClassify": true,
//                     "client": true,
//                     "ba": true,
//                 }
//             },
//             // 开票数据分析
//             "invoiceData": true,
//             // 已开票未回款清单
//             "invoicedUnreturned": {
//                 "table": true,
//                 "pie": {
//                     "overPaymentDays": true,
//                     "overPaymentReason": true,
//                     "client": true,
//                     "ba": true,
//                 },
//                 "histogram": {
//                     "overPaymentDays": true,
//                     "overPaymentReason": true,
//                     "client": true,
//                     "ba": true,
//                 }
//             },
//             // 回款数据分析
//             "returnedData": true
//         },
//         // 请款和回款报表
//         "requestAndReturnedSheet": {
//             // 请款报表
//             "requestSheet": {
//                 "table": true,
//                 "histogramSpline": true,
//             },
//             // 年度开票分析
//             "annualBillingAnalysis": true,
//             // 年度回款分析
//             "annualPaymentCollectionAnalysis": true,
//         },
//         // 客户数据查询
//         "clientDataSearch": true,
//         // AR表
//         "arSheet": true,
//         // 请款消息
//         "requestInfo": true
//     }
// }


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/constants.js